import { getAvailableCabinTypes } from '../helpers';
import { CabinType } from '../types';

/**
 * Checks if given type is a valid CabinType
 */
export const isCabinType = (
  potentialType: string | undefined,
): potentialType is CabinType => {
  //TODO: Some missing in SDK.
  return getAvailableCabinTypes().includes(potentialType as CabinType);
};
